<template>
<VueSlickgrid
  name="companyInvoices"
  :headerTitle="'Invoices'|pgettext('InvoiceLines')"
  :items="ds"
  checkbox-row-selection
  footer-totals
  export-to-csv
  :exportToCsvFilename="'company-invoices'|pgettext('filename')"
  :columnDefaults="b_7315092382398562_columnDefaults"
  :columns="b_7315092382398562_columns"
  ref="grid"
  @selectedRowsChanged="evh_7315092382398562_selectedRowsChanged($event, {})"
>
</VueSlickgrid>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class InvoiceLinesView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getQueryParameters(...args: any[]) {
    return {
      company_id: this.companyId,
      partner_id: this.partnerId,
      rental_id: this.rentalId,
      contract_id: this.contractId,
    }
  }

  @Prop({
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
  })
  partnerId!: string;

  @Watch('partnerId')
  onPartner_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("partnerId")
  }

  @Prop({
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  @Prop({
    type: String,
  })
  contractId!: string;

  @Watch('contractId')
  onContract_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contractId")
  }

  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_invoice_lines', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_columnDefaults!: any;
  b_7315092382398562_columns!: any;
  dataMembers = ['ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ds: null,
        ux: null,
        b_7315092382398562_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_7315092382398562_columns: [{
          field: "invoice_kind",
          name: this.$fn.pgettext("Invoice", "Invoice kind"),
        }
          ,
        {
          field: "invoice_type",
          name: this.$fn.pgettext("Invoice", "Invoice type"),
        }
          ,
        {
          field: "invoice_number",
          name: this.$fn.pgettext("Invoice", "Invoice number"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "invoice",
            params: {
              id: "invoice_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "invoice_date",
          name: this.$fn.pgettext("Invoice", "Invoice date"),
          type: "date",
        }
          ,
        {
          field: "fulfillment_date",
          name: this.$fn.pgettext("Invoice", "Fulfillment date"),
          type: "date",
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("InvoiceLine", "Description"),
        }
          ,
        {
          field: "quantity",
          name: this.$fn.pgettext("InvoiceLine", "Quantity"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "unit",
          name: this.$fn.pgettext("InvoiceLine", "Unit"),
        }
          ,
        {
          field: "unit_price",
          name: this.$fn.pgettext("InvoiceLine", "Price"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "discount",
          name: this.$fn.pgettext("InvoiceLine", "Discount"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("InvoiceLine", "Net"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "vat_amount",
          name: this.$fn.pgettext("InvoiceLine", "VAT"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "amount",
          name: this.$fn.pgettext("InvoiceLine", "Amount"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "tax_code",
          name: this.$fn.pgettext("InvoiceLine", "Tax Code"),
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("Invoice", "Currency"),
        }
          ,
        {
          field: "billing_period_start",
          name: this.$fn.pgettext("Invoice", "Period start"),
          type: "date",
        }
          ,
        {
          field: "billing_period_end",
          name: this.$fn.pgettext("Invoice", "Period end"),
          type: "date",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  async act_7315092382398562_setData_7766_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7315092382398562_setData_7766, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_7315092382398562_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_setData_7766: actions.SetDataAction;
    evh_7315092382398562_selectedRowsChanged_7765: actions.EventHandlerImpl;
    evh_7315092382398562_selectedRowsChanged: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_setData_7766 = new actions.SetDataAction(
      {
        actionArgs: this.act_7315092382398562_setData_7766_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_selectedRowsChanged_7765 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_setData_7766,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_7315092382398562_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_selectedRowsChanged_7765],
      }
    );
    return {
      act_7315092382398562_setData_7766,
      evh_7315092382398562_selectedRowsChanged_7765,
      evh_7315092382398562_selectedRowsChanged,
    }
  }
}

Vue.component("InvoiceLinesView", InvoiceLinesView);

</script>